import { FC } from 'react';

import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';

import Icon from '@src/main/ui/components/common/Icon/Icon';
import styles from './Views.module.scss';

interface ViewsProps {
  views?: number;
  variant: 'small' | 'medium';
}

const defaultProps = { views: undefined };

const formatViews = (views: number): string => {
  if (views >= 1_000_000) {
    return `${(views / 1_000_000).toFixed(1)}M`;
  }
  if (views >= 1_000) {
    return `${(views / 1_000).toFixed(1)}k`;
  }
  return views.toLocaleString('en');
};

const Views: FC<ViewsProps> = ({ views, variant }) => (
  <span>
    {views ? (
      <Typography variant={variant === 'small' ? 'caption' : 'body2'} color="text.secondary">
        <span className={styles.views__content}>
          {formatViews(views)}
          <Tooltip title="Views">
            <span className={styles.views__content__icon}>
              <Icon iconId="views" />
            </span>
          </Tooltip>
        </span>
      </Typography>
    ) : undefined}
  </span>
);

Views.defaultProps = defaultProps;

export default Views;
